export default __webpack_public_path__ + "static/media/koia.e7ff3aab.png";